type ServerItem = {
    key: string;
    value: string;
};

const SERVER_LIST = [
    { key: "fed", value: "wapi-eu0.febest.eu" },
    { key: "fbg", value: "wapi-eu0.febest.eu" },
    { key: "fac", value: "wapi-me0.febest.eu" },
    { key: "fae", value: "wapi-me0.febest.eu" },
    { key: "fkz", value: "wapi-kz0.febest.eu" },
    // { key: "fed", value: "ws-demo-kz.febest.dev" },
    // { key: "fbg", value: "ws-demo-kz.febest.dev" },
    // { key: "fac", value: "ws-demo-kz.febest.dev" },
    // { key: "fae", value: "ws-demo-kz.febest.dev" },
    // { key: "fkz", value: "ws-demo-kz.febest.dev" },
    // { key: "fed", value: "roman-core-ws.febest.dev" },
    // { key: "fbg", value: "roman-core-ws.febest.dev" },
    // { key: "fac", value: "roman-core-ws.febest.dev" },
    // { key: "fae", value: "roman-core-ws.febest.dev" },
] as const satisfies readonly ServerItem[];

export type ServerKey = (typeof SERVER_LIST)[number]["key"];

type ServerList = {
    get(key: ServerKey): string;
    getNext(key: ServerKey): string;
    getDefault(): string;
    getListByKeys(keys: string[]): string[];
};

const serverMap: Record<ServerKey, string> = Object.fromEntries(
    SERVER_LIST.map(({ key, value }) => [key, value])
) as Record<ServerKey, string>;

const serverKeys = SERVER_LIST.map(({ key }) => key) as ServerKey[];

const isServerKey = (key: string): key is ServerKey => key in serverMap;

export const serverList: ServerList = {
    get(key: ServerKey): string {
        return serverMap[key];
    },


    getNext(key: ServerKey): string {
        const currentIndex = serverKeys.indexOf(key);
        const nextIndex = (currentIndex + 1) % serverKeys.length;
        return serverMap[serverKeys[nextIndex]];
    },

    getDefault(): string {
        return serverMap[serverKeys[0]];
    },

    getListByKeys(keys: string[]): string[] {
        const result: string[] = [];

        for (const key of keys) {
            if (!isServerKey(key)) {
                continue;
            }

            const server = serverMap[key];

            if (!result.includes(server)) {
                result.push(server);
            }
        }

        return result;
    }
};